import apiAuth from './auth'
import { jwtAllDecoder } from './JwtDecoder'

const emailService = {
  async sendEmailWithTemplate(emails, emailTemplate, options = {}) {
    try {
      if (!Array.isArray(emails) || emails.length === 0) {
        throw new Error('Recipients list is empty')
      }

      if (!emailTemplate) {
        throw new Error('Email template is required')
      }

      const token = localStorage.getItem('accessToken')
      if (!token) {
        throw new Error('No access token found.')
      }

      const emailPromises = emails.map(async email => {
        try {
          console.log(`Attempting to send email to: ${email}`)
          const response = await apiAuth.post('/email/send', {
            recipients: [email],
            subject: options.subject || 'No Subject',
            body: emailTemplate,
            contentType: 'text/html',
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          })
          if (!response?.data) {
            throw new Error('Invalid response from email service')
          }
          return { success: true, email }
        } catch (error) {
          console.error(`Failed to send email to ${email}:`, error.response || error)

          if (error.response?.status === 401) {
            throw new Error('Token expired or invalid. Please log in again.')
          }

          throw new Error(`Failed to send email to ${email}: ${error.message}`)
        }
      })

      const results = await Promise.all(emailPromises)
      return results.length
    } catch (error) {
      console.error('Email service error:', error)
      throw error
    }
  },

  isTokenValid() {
    const token = localStorage.getItem('accessToken')
    if (!token) return false

    try {
      const decoded = jwtAllDecoder(token)
      const currentTime = Date.now() / 1000
      return decoded.exp > currentTime
    } catch {
      return false
    }
  },
}
export default emailService
